import { Skeleton } from 'antd';
import React, { memo } from 'react';
import styled from 'styled-components';
export const OrderPendingSkeleton = () => {
  return (
    <Wrapper>
      {[1, 2].map(i => (
        <Item key={i}>
          <Row>
            <Left>
              <Col>
                <Skeleton.Input active style={{ width: '50%', height: 16 }} />
              </Col>
            </Left>
            <Skeleton.Button active size="small" style={{ width: 80 }} />
          </Row>
        </Item>
      ))}
    </Wrapper>
  );
};
export default memo(OrderPendingSkeleton);
const Wrapper = styled.div`
  padding-top: 10px;
`;

const Item = styled.div`
  border: 1px solid var(--color-4);
  border-radius: 10px;
  padding: 10px;
  margin-bottom: 10px;
  padding-top: 22px;
  padding-bottom: 22px;
`;

const Row = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;
const Left = styled.div`
  flex: 1;
`;
const Col = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
`;
